import { ExperimentService } from "@Api/ExperimentService";

export class ExperimentManager
{
	private readonly experimentService: ExperimentService;

	constructor()
	{
		this.experimentService = new ExperimentService();
	}

	public AddTest = (thirdPartyTestID: string, variantSequence: number, callback?: Function): void =>
	{
		this.experimentService.AddTest(thirdPartyTestID, variantSequence, callback);
	};
}